<!--
---
--- View: User Information
---
-->
<template>
    <v-card >
        <v-alert :value="error!=null" type="error">{{error}}</v-alert>
        <v-container fluid v-if="user!=null">
            <v-layout justify-space-around fill-height>
                <v-flex xs11>
                    <v-progress-linear v-if="!user" :indeterminate="processing"/>
                    <v-card hover v-if="user">
                        <v-card-title>
                            <h2>{{$t("attributes.userSettings")}}</h2>
                        </v-card-title>
                        <v-form>
                            <v-switch class="my-radio" v-model="user.borderauWithReceipts" :label="$t('attributes.bordereauExt')" :value="user.borderauWithReceipts"></v-switch>
                            <v-switch class="my-radio" v-model="user.mailActive" :label="$t('attributes.delivery')" :value="user.mailActive"></v-switch>
                            <my-input class="pa-3" name="email" :model="user" v-validate="'required'" :readonly='true'/>

                            <my-input class="pa-3" name="firstName" :model="user" v-validate="'required'"/>
                            <my-input class="pa-3" name="lastName" :model="user" v-validate="'required'"/>

                            <!-- Update removed from dialog. The system takes the setting from the login screen
                            <v-select class="pa-3" name="language" :label="$t('attributes.language')"
                                      v-model="user.language"
                                      :items="languageArray" required/>
                            -->

                            <v-btn color="primary" @click="cancel()" :loading="processing"
                                   :disabled="processing || !saveActive">{{ $t("attributes.cancel") }}
                            </v-btn>

                            <v-btn color="primary" @click="submit" :loading="processing"
                                   :disabled="processing || !saveActive">{{ $t("attributes.saveAction") }}
                            </v-btn>
                        </v-form>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>

</template>

<script>
    import MyInput from '@/components/MyInput.vue'
    import MyMixin from '@/mixin'
    import WebService from "@/services/WebService"
    import '@/services/CustomValidations'

    export default {
        name: "my-user",

        mixins: [MyMixin],

        components: {
            MyInput
        },

        data: () => ({
            user: null,
            processing: false,
            languageArray: ['de', 'fr', 'en'],
            saveActive: false,
            cancelActive: false
        }),

        methods: {
            // save the data
            submit() {
                this.processing = true
                var this_ = this
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // clear pdf documents
                        this_.$store.dispatch('clearPDF')
                        // post registration data via Axios
                        var webService = new WebService(this_)
                        console.log(this_.user)
                        webService.saveUser(this_.user)
                            .then(response => {
                                console.log('Response', response)
                                if (response.status == 204) {
                                    console.log("response" + response.data)
                                    this_.$store.dispatch('setUser', this.user)
                                    
                                    this.saveActive = false
                                } else {
                                    this_.$store.dispatch('setError', response)
                                }
                                this_.processing = false
                            }).catch(e => {
                            console.log(e)
                            this_.processing = false
                            this_.$store.dispatch('setError', e.message)

                        })
                    } else {
                        this.processing = false
                        this.$store.dispatch('setError', this.$t('attributes.missingValues'))
                    }
                });
            },

            // reset to initial state
            cancel() {
                //this.user = this.$store.state.user
                this.user = JSON.parse(JSON.stringify(this.$store.state.user));
                this.saveActive = false
                this.cancelActive = true
            }
        },

        computed: {
            // determine error message
            error() {
                return this.$store.state.error
            },

            mailDeliveryOptionsArray: function () {
                return [{title:this.$t('attributes.delivery'),value:true}, {title:this.$t('attributes.no-delivery'),value:false} ]
            },

        },

        watch: {
            // if this setting is changed we need to delete the cached pdfs from the pdf store
            borderauWithReceipts: {
                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    this.$store.dispatch('clearPDF')
                }
            },


            // only activate the save button if the user has changed
            user: {
                deep: true,
                immediate: false,

                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    // we only consider attribute updates - prevent this when we cancel
                    if (oldVal!=null && !this.cancelActive){
                        this.saveActive = true
                    }
                    // reactivate regular logic
                    this.cancelActive = false
                }
            },

        },

        mounted() {
            // use cloned object becaue we do not want to update the object in the store
            // directly
            //this.user = this.$store.state.user
            this.user = JSON.parse(JSON.stringify(this.$store.state.user));

        }
    }
</script>

<style scoped>
    .my-radio {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
